import { SET_CONFIGURATION } from './configuration.actions';
import { ConfigurationActions, ConfigurationState } from './configuration.types';

export const INITIAL_CONFIGURATION_STATE: ConfigurationState = {
    data: null
};

export const configurationsReducer = (
    state: ConfigurationState = INITIAL_CONFIGURATION_STATE,
    action: ConfigurationActions
): ConfigurationState => {
    switch (action.type) {
    case SET_CONFIGURATION: {
        return {
            ...state,
            data: action.payload
        };
    }

    default:
        return state;
    }
};
